// @flow

import { getApi, postRaw } from './api.core'

export const getProviders = params =>
  getApi('api/marketplace/provider/', params)
export const postProvider = params =>
  postRaw(`api/marketplace/provider/`, params)
